/**
 * Stillora Atelier — mobile title hoist
 *
 * On screens ≤ 749px, move the product title (first <h1>/<h2> inside
 * .product-details > .group-block) into a separate node placed BEFORE
 * .product-information__media. On larger screens it stays in place.
 *
 * Idempotent — safe to run on every page render & resize.
 */
(function () {
  'use strict';

  const MOBILE_MAX = 1099;
  let originalParent = null;
  let originalNextSibling = null;
  let titleEl = null;

  function findTitle() {
    // First .product-details — find its first heading
    const details = document.querySelector('.product-details');
    if (!details) return null;
    const heading = details.querySelector('.group-block h1, .group-block h2, h1, h2');
    return heading ? heading.closest('.group-block') || heading : null;
  }

  function hoist() {
    if (!titleEl) titleEl = findTitle();
    if (!titleEl) return;

    if (window.innerWidth > MOBILE_MAX) {
      // Restore original position if we moved it
      if (originalParent && titleEl.parentElement !== originalParent) {
        originalParent.insertBefore(titleEl, originalNextSibling);
        titleEl.classList.remove('stillora-mobile-title-hoisted');
      }
      return;
    }

    // Mobile: move above the gallery
    const grid = document.querySelector('.product-information__grid');
    const media = document.querySelector('.product-information__media');
    if (!grid || !media) return;

    if (titleEl.parentElement !== grid || titleEl.nextElementSibling !== media) {
      // Save original location once
      if (!originalParent) {
        originalParent = titleEl.parentElement;
        originalNextSibling = titleEl.nextSibling;
      }
      grid.insertBefore(titleEl, media);
      titleEl.classList.add('stillora-mobile-title-hoisted');
      titleEl.style.gridArea = 'title';
      titleEl.style.textAlign = 'center';
      titleEl.style.width = '100%';
    }
  }

  // Run on load and resize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoist);
  } else {
    hoist();
  }
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(hoist, 120);
  });

  // Re-run when Shopify section is re-rendered (theme editor / variant change)
  document.addEventListener('shopify:section:load', hoist);
  document.addEventListener('shopify:section:select', hoist);
})();
